import * as React from "react";
import { connect } from "react-redux";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import TeamsFormContainer from "tsx/routes/team-form";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/default
import Teams from "tsx/routes/teams";

import Redirect from "components/Redirect";
import { IStoreState } from "interfaces/storeState";
import { withRememberLastRoute } from "routes/withRememberLastRoute";
import { getCurrentAgentId } from "store/features/session";

import Agents from "./Agents";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-named-as-default
import AgentFormContainer from "./agent-form/AgentFormContainer";
import { AgentsRoutes } from "./constants";

interface IStateProps {
  currentAgentId: string;
}

interface IProps extends IStateProps, RouteComponentProps {}

const Router: React.FC<IProps> = ({ currentAgentId }) => (
  <Switch>
    <Route exact path="/agents/teams/add" component={TeamsFormContainer} />
    <Route exact path="/agents/teams/:id/edit" component={TeamsFormContainer} />
    <Route exact path="/agents/teams/:id?" component={Teams} />
    <Route exact path="/agents/me/edit" render={() => <Redirect to={`/agents/${currentAgentId}/edit`} />} />
    <Route exact path="/agents/:id/edit" component={AgentFormContainer} />
    <Route exact path="/agents/me" render={() => <Redirect to={`/agents/${currentAgentId}`} />} />
    {/* @ts-expect-error TS(2322): Type '{ history: History<unknown>; location: Locat... Remove this comment to see the full error message */}
    <Route exact path="/agents/add" render={({ ...props }) => <Agents showAddModalOnInit {...props} />} />
    <Route path="/agents/:id?" component={Agents} />
  </Switch>
);

const mapStateToProps = (state: IStoreState): IStateProps => ({
  // @ts-expect-error TS(2322)
  currentAgentId: getCurrentAgentId(state),
});

export default withRememberLastRoute(connect(mapStateToProps, null)(Router), AgentsRoutes.Agents);
